import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Frisbeegolf — yleistä' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Frisbeegolf"
			title="Mitä frisbeegolf on?"
			intro="Lajin perusteet ja miten pääset alkuun."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
